export const SERVICE_URL_LOCAL = "http://localhost:5078/api/";
export const SERVICE_URL_PROD =
  "https://finworld001-g8cgetfzc4abfagj.eastasia-01.azurewebsites.net/api/";
export const CONST_ENV_VAR = process.env.NODE_ENV + "1";
